var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2544 3.62295L11.4715 3.64434L2.68858 3.60156H2.6843C1.50355 3.60156 0.56665 4.70958 0.56665 6.09568V17.7064C0.56665 19.0925 1.50355 20.2005 2.6843 20.2005H20.2672C21.4479 20.2005 22.3848 19.0925 22.3848 17.7064V6.09568C22.3848 4.70958 21.4565 3.62295 20.2544 3.62295ZM19.5656 5.33418L11.7196 12.5085L11.6896 12.5342L11.664 12.5641C11.5699 12.6668 11.4586 12.6796 11.3987 12.6796C11.3388 12.6796 11.2276 12.6625 11.1378 12.5556L11.1121 12.5256L3.61264 5.29996L11.4715 5.35129L19.5656 5.33418ZM20.2672 18.4893H2.6843C2.53456 18.4893 2.27788 18.2069 2.27788 17.7064V6.36948L9.87574 13.7107C10.2608 14.1385 10.8041 14.3866 11.3816 14.3951H11.4073C11.9763 14.3951 12.5068 14.1599 12.8961 13.7492L20.6822 6.62188V17.7064C20.6736 18.2069 20.4169 18.4893 20.2672 18.4893Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingMail);
export default __webpack_public_path__ + "static/media/landing-mail.526c59dd111ffd93cc0897747a73b847.svg";
export { ForwardRef as ReactComponent };